import { Accordion, styled } from "@mui/material";

export const CustomAccordion = styled(Accordion)({
  backgroundColor: "#fff1f2",
  borderRadius: "24px",
  boxShadow: "none",
  marginBottom: "16px",

  "&::before": {
    display: "none",
  },

  "&:last-of-type": {
    borderRadius: "24px",
  },
});

export const CustomInnerAccordion = styled(Accordion)({
  backgroundColor: "#FFFFFF",
  marginBottom: "16px",
  borderRadius: "24px",
  boxShadow: "none",

  "&::before": {
    display: "none",
  },

  "&:first-of-type": {
    borderTopLeftRadius: "24px",
    borderTopRightRadius: "24px",
  },

  "&:last-of-type": {
    borderBottomLeftRadius: "24px",
    borderBottomRightRadius: "24px",
  },

  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#171717",
  },
});
